import React, { useMemo } from 'react';

import { ModalEntryPoint } from '../shared/modal-entry-point';

import { DIALOG_CONFIG } from './dialog-config';
import { entryPoint } from './standardToPremiumIncentiveOfferModal.entrypoint';

export function StandardToPremiumIncentiveOfferModal(): React.JSX.Element | null {
	const modalProps = useMemo(() => ({ width: 600 }), []);

	return (
		<ModalEntryPoint entryPoint={entryPoint} modalProps={modalProps} dialogConfig={DIALOG_CONFIG} />
	);
}
